import './reviews.component.scss'
import { Swiper, Navigation, Autoplay } from 'swiper'
import { breakpoints } from '../../application/utils/breakpoints'
Swiper.use(Navigation)
Swiper.use(Autoplay)

document.querySelectorAll('.reviews').forEach((root) => {
  new Swiper(root.querySelector('.swiper-container'), {
    slidesPerView: 1,
    spaceBetween: 50,
    autoHeight: true,
    loop: true,
    autoplay: {
      delay: 5000,
      disableOnInteraction: false
    },
    navigation: {
      prevEl: root.querySelector('button[data-prev]'),
      nextEl: root.querySelector('button[data-next]')
    },
    breakpoints: {
      [breakpoints.medium + 1]: {
        autoHeight: false
      }
    }
  })
})
